class ContactFormSidebar extends HTMLElement {
    constructor() {
      super();

      const sidebarOverlay = this.querySelector('.reason-sidebar-overlay')
      const sidebar = this.querySelector('.reason-sidebar')
      const inputReason = this.querySelector('#ContactForm-reason');
      const sidebarCloseButton = this.querySelector('.reason-sidebar-close')
      const applyButton = this.querySelector('.sidebar-apply')
      const sidebarSelections = this.querySelectorAll('.sidebar-selection')

      inputReason.addEventListener('click', this.showSidebar);
      inputReason.addEventListener('focus', this.showSidebar);
      // inputReason.addEventListener('focusout', this.hideSidebar)
      sidebarCloseButton.addEventListener('click', this.hideSidebar)
      sidebarOverlay.addEventListener('click', this.overlayClick)
      sidebar.addEventListener('click', (e) => {e.stopPropagation()})
      applyButton.addEventListener('click', this.applySelection)
      sidebarSelections.forEach(select => select.addEventListener('click', this.selectOption))
      
    }
    showSidebar() {
      const sidebarOverlay = document.querySelector('.reason-sidebar-overlay')
      sidebarOverlay.classList.add('active');
    }
    hideSidebar() {
      const sidebarOverlay = document.querySelector('.reason-sidebar-overlay')
      sidebarOverlay.classList.remove('active');
    }
    overlayClick() {
      const sidebarOverlay = document.querySelector('.reason-sidebar-overlay')
      sidebarOverlay.classList.remove('active');
    }
    selectOption(e) {
      const element = e.target.closest('.sidebar-selection')
      if(element.classList.contains("active")){return}

      const sidebarSelections = document.querySelectorAll('.sidebar-selection')

      sidebarSelections.forEach(el => {
        const svgEl = el.querySelector('svg')

        if(svgEl !== null) {
          svgEl.remove();
        }
        el.classList.remove('active')
      })

      element.classList.add('active')
      element.insertAdjacentHTML('afterbegin', '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" fill="none" viewBox="0 0 14 10"><path stroke="#333" d="m1 5 4 4L13.5.5"/></svg>')
    }
    applySelection() {
      const selected = document.querySelector('.sidebar-selection.active span')
      const inputReason = document.querySelector('#ContactForm-reason');

      inputReason.value = selected.innerHTML.trim(); 

      const sidebarOverlay = document.querySelector('.reason-sidebar-overlay')
      sidebarOverlay.classList.remove('active');
    }
  }
  
  customElements.define('contact-form-sidebar', ContactFormSidebar);